<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144112' | translate }} {{ title | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      @if(!isCreate){
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ml_144072' | translate}}</mat-label>
            <mat-select formControlName="status">
              @for (item of statusSelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      }

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144010' | translate}}</mat-label>
            <input matInput placeholder="" formControlName="title" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144111' | translate}}</mat-label>
            <textarea matInput placeholder="" formControlName="body" rows="3"></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100 file-selector">
            <mat-label>{{'ml_144011' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="attachment" />
            <button type="button" mat-raised-button (click)="fileInput.click()">{{'ml_144144' | translate}}</button>
            <span class="ms-3">{{ 'ml_151172' | translate }}</span>
          </mat-form-field>
          <input hidden (change)="onFileSelected($event)" type="file" #fileInput id="file">
        </div>
      </div>

      @if(isCreate){
      <div class="row">
        <div class="col">
          <mat-radio-group (change)="onReceiverTypeChange($event)" formControlName="teamMessageReceiverType" class="row">
            @if(countrySelectVisiable){
            <div class="col">
              <mat-radio-button class="material-icons blue" [value]="teamMessageReceiverType.COUNTRY">
                {{'ml_143912' | translate}}
              </mat-radio-button>
            </div>
            }
            @if(subRegionSelectVisable){
            <div class="col">
              <mat-radio-button class="material-icons blue" [value]="teamMessageReceiverType.SUB_REGION">
                {{'ml_143911' | translate}}
              </mat-radio-button>
            </div>
            }
            <div class="col">
              <mat-radio-button class="material-icons blue" [value]="teamMessageReceiverType.TERMINAL">
                {{'ml_144113' | translate}}
              </mat-radio-button>
            </div>
            <div class="col">
              <mat-radio-button class="material-icons blue" [value]="teamMessageReceiverType.DRIVER">
                {{'ml_144114' | translate}}
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
      </div>
      <div class="row mt-1">
        @switch (editForm.controls.teamMessageReceiverType.value) {
        @case (teamMessageReceiverType.COUNTRY) {
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143912' | translate}}</mat-label>
            <mat-select formControlName="country">
              @for (item of countrySelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        @case (teamMessageReceiverType.SUB_REGION) {
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143911' | translate}}</mat-label>
            <mat-select formControlName="subRegion_Id">
              @for (item of subRegionSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        @case (teamMessageReceiverType.TERMINAL) {
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144113' | translate}}</mat-label>
            <mat-select formControlName="terminal_Ids" [disabled]="processing$ | async" multiple>
              @for (item of terminalSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        @case (teamMessageReceiverType.DRIVER) {
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144113' | translate}}</mat-label>
            <mat-select multiple formControlName="driverTerminals" [disabled]="processing$ | async" (selectionChange)="driverTerminalsSelectionChanged($event)">
              @for (item of terminalSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_144114' | translate}}</mat-label>
            <mat-select formControlName="driver_Ids" multiple>
              @for (item of dirverSelectItems$ | async; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        }

      </div>
      }
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
